/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Title_LabelInputs */

const th_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เรื่องอะไร`)
};

const en_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is it about?`)
};

const ja_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用件は何ですか`)
};

const zh_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关于什么？`)
};

const es_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿De qué se trata?`)
};

const pt_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sobre o que é?`)
};

const id_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tentang apa?`)
};

const fr_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De quoi s’agit-il ?`)
};

const tl_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tungkol saan?`)
};

const vi_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Về việc gì?`)
};

const ko_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`어떤 내용인가요?`)
};

const de_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Worum geht es?`)
};

const ru_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`О чём встреча?`)
};

const tr_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konu nedir?`)
};

const it_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Di cosa si tratta?`)
};

const pl_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Czego dotyczy?`)
};

const uk_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Про що зустріч?`)
};

const hi_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`किस बारे में?`)
};

const ar_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عن ماذا؟`)
};

const ms_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengenai apa?`)
};

const bn_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কী নিয়ে?`)
};

const zh_tw2_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關於什麼？`)
};

const zh_hk2_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`關於什麼？`)
};

const ur_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`کس بارے میں؟`)
};

const fa_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`دربارهٔ چه؟`)
};

const sw_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuhusu nini?`)
};

const nl_meeting_title_label = /** @type {(inputs: Meeting_Title_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waar gaat het over?`)
};

/**
* | output |
* | --- |
* | "What is it about?" |
*
* @param {Meeting_Title_LabelInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const meeting_title_label = /** @type {((inputs?: Meeting_Title_LabelInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Title_LabelInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_meeting_title_label(inputs)
	if (locale === "ja") return ja_meeting_title_label(inputs)
	if (locale === "zh") return zh_meeting_title_label(inputs)
	if (locale === "es") return es_meeting_title_label(inputs)
	if (locale === "pt") return pt_meeting_title_label(inputs)
	if (locale === "id") return id_meeting_title_label(inputs)
	if (locale === "fr") return fr_meeting_title_label(inputs)
	if (locale === "tl") return tl_meeting_title_label(inputs)
	if (locale === "vi") return vi_meeting_title_label(inputs)
	if (locale === "ko") return ko_meeting_title_label(inputs)
	if (locale === "de") return de_meeting_title_label(inputs)
	if (locale === "ru") return ru_meeting_title_label(inputs)
	if (locale === "tr") return tr_meeting_title_label(inputs)
	if (locale === "it") return it_meeting_title_label(inputs)
	if (locale === "pl") return pl_meeting_title_label(inputs)
	if (locale === "uk") return uk_meeting_title_label(inputs)
	if (locale === "hi") return hi_meeting_title_label(inputs)
	if (locale === "ar") return ar_meeting_title_label(inputs)
	if (locale === "ms") return ms_meeting_title_label(inputs)
	if (locale === "bn") return bn_meeting_title_label(inputs)
	if (locale === "zh-TW") return zh_tw2_meeting_title_label(inputs)
	if (locale === "zh-HK") return zh_hk2_meeting_title_label(inputs)
	if (locale === "ur") return ur_meeting_title_label(inputs)
	if (locale === "fa") return fa_meeting_title_label(inputs)
	if (locale === "sw") return sw_meeting_title_label(inputs)
	if (locale === "nl") return nl_meeting_title_label(inputs)
	return en_meeting_title_label(inputs)
});